require('sass/blocks/geoaddress/geofields/georowgroup.scss');
import React from 'react';
import PropTypes from 'prop-types';

const GeoRowGroup = ({ children, baseModelDescriptor, baseModelForm, formActions }) => {
    const getChildren = () =>
        React.Children.map(children, child => {
            return React.cloneElement(child, {
                baseModelDescriptor: baseModelDescriptor,
                baseModelForm: baseModelForm,
                formActions: formActions,
            });
        });

    return <div className="geo-row-group row">{getChildren()}</div>;
};

GeoRowGroup.propTypes = {
    children: PropTypes.arrayOf(PropTypes.node),
    baseModelDescriptor: PropTypes.string,
    baseModelForm: PropTypes.object,
    formActions: PropTypes.object,
};

GeoRowGroup.displayName = 'GeoRowGroup';

export default GeoRowGroup;
